<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-07"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          {{ $t("title.tag.management.title") }}
        </label>
        <sp-smart-button  v-if="$checkAuth('010309')" slot="cancel" class="cancel-btn" @click="clickCancel">
          {{ $t("button.common.data.cancel") }}
        </sp-smart-button>
        <narrow-down v-if="$checkAuth('010310')" slot="create" class="create-btn" @click="saveBtn">
          {{ $t("button.common.data.save") }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <div class="introduce">
        <ul>
          <li>
            {{ $t("label.tag.management.introduction1") }}
          </li>
          <li>
            {{ $t("label.tag.management.introduction2") }}
          </li>
          <li>
            {{ $t("label.tag.management.introduction3") }}
          </li>
        </ul>

        <div class="tips">
          <div class="tips-left m-right-5">
            <h4>{{ $t("label.tag.management.unclassifiedTags") }}</h4>
            <p>{{ $t("label.tag.management.unclassifiedTagsNotDisplay") }}</p>
          </div>
          <div class="tags-display tips-right" @dragover.prevent @drop="handleDrop(UnclassifiedTags, UnclassifiedTags.length)">
            <el-tag v-for="(tag, index) in UnclassifiedTags" class="tag" :key="tag.displayOrder" closable
              @close="handleClose(tag)" draggable="ture" @dragstart.native="startDrag(index, UnclassifiedTags)"
              @dragover.prevent.native @drop.native="handleDrop(UnclassifiedTags, index)">
              {{ tag.meetingTagName }}
            </el-tag>
            <Add v-if="$checkAuth('010310')" class="addNewTag" @click="showInput" />
            <tag-input v-if="inputVisible" v-model="unclassifiedTagName" class="tag-input" @handleBlur="handleInputConfirm" @keyup.enter.native="handleInputConfirm" @closeTagInput="showInput">
            </tag-input>
          </div>
        </div>
      </div>
      <div class="panel">
        <el-table class="m-bottom-3" :data="meetingTagGroupList" :span-method="rowMerge">

          <!-- 表示順 -->
          <el-table-column
            prop="displayOrder"
            class-name="col-2"
            :label="$t('label.tag.management.displayOrder')">

            <template slot-scope="scope">
              <div class="display-order">
                <div class="m-right-3">
                  {{ scope.row.index }}
                </div>
                <div class="orderBtns">
                  <sp-smart-button v-if="$checkAuth('010310')" class="orderButton" :class="[scope.row.index == '1' ? 'disabled' : 'abled']"  @click="adjustOrder(scope.row, -1)" :disabled="scope.row.index == '1'">
                    <i class="el-icon-caret-top"></i>
                  </sp-smart-button>
                  <sp-smart-button v-if="$checkAuth('010310')" class="orderButton" :class="[scope.row.index == meetingTagGroupList.length ? 'disabled' : 'abled']" @click="adjustOrder(scope.row, +1)" :disabled="scope.row.index == meetingTagGroupList.length">
                    <i class="el-icon-caret-bottom"></i>
                  </sp-smart-button>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- タググループ名 -->
          <el-table-column
            prop="meetingTagGroupName"
            :label="$t('label.tag.management.tagGroupName')"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.meetingTagGroupId == null" class="input-group">
                <el-input class="input" v-model="scope.row.meetingTagGroupName" maxlength="8" show-word-limit size="small" />
                <div class="inputBtn">
                  <sp-smart-button v-if="$checkAuth('010310')" class="btn btn-save" @click="saveTagGroup(scope.row)">
                    {{ $t("button.common.data.save") }}
                  </sp-smart-button>
                  <sp-smart-button v-if="$checkAuth('010310')" class="btn" @click.native="cancelTagGroup(scope.row)">
                    {{ $t("button.common.data.cancel") }}
                  </sp-smart-button>
                </div>
              </div>
              <div v-else class="tag_group_name">{{ scope.row.meetingTagGroupName }}</div>
            </template>
          </el-table-column>

          <!-- タグ -->
          <el-table-column
            prop=""
            class-name="col-8"
            :label="$t('label.tag.management.tag')"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.meetingTagGroupId != null" @dragover.prevent class="tags-display"
                @drop="handleDrop(scope.row.meetingTagList, scope.row.meetingTagList.length)" >
                <el-tag v-for="(tag, index) in scope.row.meetingTagList" class="tag" :key="index" closable
                  @close="handleClose(tag, scope.row)" draggable="ture"
                  @dragstart.native="startDrag(index, scope.row.meetingTagList)" @dragover.prevent.native
                  @drop.native="handleDrop(scope.row.meetingTagList, index)">
                  {{ tag.meetingTagName }}
                </el-tag>
                <Add v-if="$checkAuth('010310')" class="addNewTag" @click="showTagInput(scope.row)" />
                <tag-input
                  v-if="scope.row.showFlag"
                  v-model="newMeetingTagName"
                  class="tag-input"
                  @handleBlur="addTags(scope.row)"
                  @closeTagInput="showTagInput(scope.row)"
                  @keyup.enter.native="addTags(scope.row)" />
              </div>
            </template>
          </el-table-column>

          <!-- タグの優先表示 -->
          <el-table-column
            prop=""
            class-name="col-4"
            :label="$t('label.tag.management.reserveTopDisplay')"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.reserveTopDisplayOrder == '01'">
                {{ $t("label.tag.management.tagGroup1") }}
                <span v-if="scope.row.reserveTopDisplayStatus == '01'">
                {{ $t("label.tag.management.tagShowUsually") }}
                </span>
                <span v-if="scope.row.reserveTopDisplayStatus == '02'">
                  {{ $t("label.tag.management.tagShowImage") }}
                </span>
              </div>
              <div v-if="scope.row.reserveTopDisplayOrder == '02'">
                {{ $t("label.tag.management.tagGroup2") }}
                <span v-if="scope.row.reserveTopDisplayStatus == '01'">
                  {{ $t("label.tag.management.tagShowUsually") }}
                </span>
                <span v-if="scope.row.reserveTopDisplayStatus == '02'">
                  {{ $t("label.tag.management.tagShowImage") }}
                </span>
              </div>
              <div v-if="!scope.row.homeDisplayFlag && scope.row.reserveTopDisplayStatus == ''">
                {{ $t("label.tag.management.none") }}
              </div>
              <div v-if="scope.row.homeDisplayFlag">
                {{ $t("label.tag.management.homePage") }}
              </div>
            </template>
          </el-table-column>

          <!-- btn -->
          <el-table-column class-name="col-3" align="right">
            <template slot-scope="scope">
              <div class="buttons" v-if="scope.row.meetingTagGroupId != '' && scope.row.meetingTagGroupId != null">
                <sp-smart-button v-if="$checkAuth('010310')" class="btn btn-edit" @click="tagGroupEditing(scope.row)">
                  {{ $t("button.common.data.edit") }}
                </sp-smart-button>
                <sp-smart-button v-if="$checkAuth('010310')" class="btn btn-remove" @click="isDeleteTagGroupShow(scope.row)">
                  {{ $t("button.common.data.delete") }}
                </sp-smart-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom-btn">
        <narrow-down v-if="$checkAuth('010310')" class="add-tag-btn" @click="addTagGroup">
          {{ $t("button.tag.management.addTagGroup") }}
        </narrow-down>
        <sp-smart-button v-if="$checkAuth('010310')" class="tag-preferences-btn" @click="clickFn">
          {{ $t("button.tag.management.tagGroupPrioritySettings") }}
        </sp-smart-button>
      </div>


      <outlook-tag-priority-popup
        :isShowPopup.sync="showTagPopup"
        :buildingId="this.paramBuildingId"
        @close="closePopup"
      />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="deleteTagGroupIsShow"
        :msgParam="deleteTagGroupMsgParam"
        @on-isPassParam="isPassDeleteTagGroup">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />

    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard";
import HeadTitle from "@/components/common/head/head";
import SpSmartButton from "@/components/common/sp-smart-button";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import Add from "@/components/common/generalButton/TagAdd";
import TagInput from "@/components/common/input/TagInput";
import OutlookTagPriorityPopup from "@/components/system/popup/OutlookTagPriorityPopup";
import elDialogPrompt from "@/components/common/el-dialog-prompt"


export default {
  name: "tagList",
  components: { LoadingDialog, MainLayout, Menubar, HeadTitle, NarrowDown, SpSmartButton, Add, TagInput, OutlookTagPriorityPopup, elDialogPrompt },
  data () {
    return {
      deleteRow: null,
      deleteTagGroupIsShow: false,
      type: null,
      msgParam: "未分類のタグがありますがよろしいですか？",
      deleteTagGroupMsgParam: this.$t("message.common.validation.deleteMessage",{
        field: this.$t("label.tag.management.tagGroup")
      }),
      paramBuildingId: null,
      tagInputflg: true,
      inputVisible: false,
      inputValue: '',
      buildingId: '',
      tag: {
        id: '',
        name: '',
        unit: '',
        label: ''
      },
      meetingTagGroupList: [],
      earlyViewMeetingTagGroupList:[],
      UnclassifiedTags: [],
      sourceIndex: null,
      sourceTagList: null,
      showTagPopup: false,
      centerDialogVisibleIsShow: false,
      showLoading: false,
      deleteMeetingTagIdList: [],
      unclassifiedTagName: null,
      newMeetingTagName: null,
      btnFlag:'',
      paramTagGroupId:''
    }
  },
  created () {
    this.$authCheck('010309')

    this.paramBuildingId = this.$route.params.buildingId;
    this.type = this.$route.query.type;

    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/buildings/search",
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
        path: "",
        title: "タグの管理",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  mounted () {
    this.loadTagInfo()
  },
  methods: {
    loadTagInfo () {
      this.showLoading = true;
      this.meetingTagGroupList = []
      SystemManageApi.OutlookBuildMeetingTagGet(this.paramBuildingId)
        .catch((error) => {
          errorCodeMsg(error, this);
        })
        .then(({ data }) => {
          this.meetingTagGroupList = []
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }
          if (data.body !== undefined && data.body !== null && data.body.length > 0) {
            data.body.forEach((info) => {
              if (info.meetingTagGroupId !== null && info.meetingTagGroupId !== '') {
                this.meetingTagGroupList.push({
                  buildingId: info.buildingId,
                  meetingTagGroupId: info.meetingTagGroupId,
                  meetingTagGroupName: info.meetingTagGroupName,
                  homeDisplayFlag: info.homeDisplayFlag,
                  reserveTopDisplayStatus: info.reserveTopDisplayStatus,
                  reserveTopDisplayOrder: info.reserveTopDisplayOrder,
                  displayOrder: info.displayOrder,
                  meetingTagList: info.meetingTagList.sort((a, b) => a.displayOrder - b.displayOrder),
                  showFlag: false
                })
              } else {
                this.UnclassifiedTags = info.meetingTagList.sort((a, b) => a.displayOrder - b.displayOrder)
              }
            })

            this.meetingTagGroupList.sort((a, b) => {return a.displayOrder - b.displayOrder})
            for (var i = 0; i < this.meetingTagGroupList.length; i++) {
              this.meetingTagGroupList[i].index =  i + 1
            }
            // JSON.parse(JSON.stringify(this.meetingTagGroupList))
            this.earlyViewMeetingTagGroupList =  JSON.parse(JSON.stringify(this.meetingTagGroupList))
            this.earlyViewUnclassifiedTags =  JSON.parse(JSON.stringify(this.UnclassifiedTags))
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (!this.deepCompareObjects(arr1[i], arr2[i])) {
          return false;
        }
      }
      return true;
    },
    deepCompareObjects(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        const val1 = obj1[key];
        const val2 = obj2[key];
        const areObjects = this.isObject(val1) && this.isObject(val2);
        if (
          (areObjects && !this.deepCompareObjects(val1, val2)) ||
          (!areObjects && val1 !== val2)
        ) {
          return false;
        }
      }

      return true;
    },
    isObject(obj) {
      return obj !== null && typeof obj === 'object';
    },
    handleClose (tag, row) {
      if (this.$checkAuth('010310')) {
        if (row == undefined) {
          this.UnclassifiedTags.splice(this.UnclassifiedTags.indexOf(tag), 1);
        } else {
          row.meetingTagList.splice(row.meetingTagList.indexOf(tag), 1);
        }
        this.deleteMeetingTagIdList.push(tag.meetingTagId);
      }
    },

    handleInputConfirm () {
      if (this.unclassifiedTagName != '' && this.unclassifiedTagName != null) {
        this.UnclassifiedTags.push({
          meetingTagName: this.unclassifiedTagName
        });
        this.inputVisible = false;
        this.unclassifiedTagName = null;
      }
    },

    showInput () {
      this.unclassifiedTagName = null;
      this.inputVisible = !this.inputVisible;
    },

    showTagInput (val) {
      this.newMeetingTagName = null;
      if (val.meetingTagList.length < 20) {
        val.showFlag = !val.showFlag
      }
    },

    clickCancel () {
      if (this.type == '01') {
        this.$router.push({
          name: 'system-building-manage-menu',
          params: {
            buildingId: this.paramBuildingId
          }
        });
      } else if (this.type == '02') {
        this.$router.push({
          name: 'user-outlook-seeting'
        });
      }

    },

    saveBtn () {
      this.btnFlag =''
      if (this.UnclassifiedTags !== null && this.UnclassifiedTags.length > 0) {
        this.msgParam= "未分類のタグがありますがよろしいですか？"
        this.centerDialogVisibleIsShow = true
      } else {
        this.save();
      }
    },

    isPassParam (param) {
      if (param) {
        this.save();
      }
    },

    save () {
      this.showLoading = true
      let meetingTagGroupList = []
      let deleteMeetingTagIdList = this.deleteMeetingTagIdList
      let updataInfo = null
      this.meetingTagGroupList.forEach((info) => {
        meetingTagGroupList.push({
          meetingTagGroupId: info.meetingTagGroupId,
          meetingTagGroupName: info.meetingTagGroupName,
          displayOrder: info.displayOrder,
          meetingTagList: info.meetingTagList,
        })
      })
      if (this.UnclassifiedTags !== null && this.UnclassifiedTags.length > 0) {
        var unclassifiedTags = []
        for (var i = 0; i < this.UnclassifiedTags.length; i++) {
          unclassifiedTags.push({
            meetingTagId:  (this.UnclassifiedTags[i].meetingTagId != undefined && this.UnclassifiedTags[i].meetingTagId != null) ?  this.UnclassifiedTags[i].meetingTagId : null,
            meetingTagName: this.UnclassifiedTags[i].meetingTagName,
            displayOrder: i + 1
          })
        }

        meetingTagGroupList.push({
          meetingTagGroupId: null,
          meetingTagGroupName: null,
          displayOrder: 0,
          meetingTagList: unclassifiedTags
        })
      }
      updataInfo = {
        meetingTagGroupList,
        deleteMeetingTagIdList,
      }
      SystemManageApi.OutlookBuildMeetingTagGroupUpdate(this.paramBuildingId, updataInfo)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$messageIotSuccess(this.$t("message.common.updateSuccess",{
              field: 'タググループ'
            }));
          if(this.btnFlag == 'tagGroupEditing'){
            this.$router.push({
              name: "outlookTagGroupsEditing",
              params: {
                meetingTagGroupId: this.paramTagGroupId
              },
              query: {
                buildingId: this.paramBuildingId
              },
            });
          }else if(this.btnFlag == 'tagGroupDisplaySettings'){
            this.showLoading = false
            this.showTagPopup = true;
          }else{
            this.meetingTagGroupList = []
            this.loadTagInfo()
          }

        })
        .finally(() => {
          this.showLoading = false
        })

    },

    adjustOrder (row, i) {
      const currentIndex = this.meetingTagGroupList.indexOf(row);
      const targetIndex = currentIndex + i;
      if (targetIndex >= 0 && targetIndex < this.meetingTagGroupList.length) {
        const tempOrder = this.meetingTagGroupList[currentIndex].displayOrder;
        const tempIndex = this.meetingTagGroupList[currentIndex].index;
        this.meetingTagGroupList[currentIndex].displayOrder = this.meetingTagGroupList[targetIndex].displayOrder;
        this.meetingTagGroupList[currentIndex].index = this.meetingTagGroupList[targetIndex].index;
        this.meetingTagGroupList[targetIndex].displayOrder = tempOrder;
        this.meetingTagGroupList[targetIndex].index = tempIndex;
      }
      this.changeTableSort();
    },

    changeTableSort () {
      this.meetingTagGroupList.sort(function (a, b) {
        return a.index - b.index
      })
    },

    changeTableIndex () {
      for (var i = 0; i < this.meetingTagGroupList.length; i++) {
        this.meetingTagGroupList[i].index =  i + 1;
        this.meetingTagGroupList[i].displayOrder =  i + 1;
      }
    },

    addTagGroup () {
      if (this.meetingTagGroupList.length < 26) {
        const order = this.meetingTagGroupList.length + 1;
        this.meetingTagGroupList.push({
          index: order,
          buildingId: this.paramBuildingId,
          meetingTagGroupId: null,
          meetingTagGroupName: null,
          homeDisplayFlag: false,
          reserveTopDisplayStatus: null,
          displayOrder: order,
          meetingTagList: [],
          showFlag: false
        })
      }
    },

    cancelTagGroup (row) {
      this.meetingTagGroupList.splice(this.meetingTagGroupList.indexOf(row), 1);
      this.changeTableIndex();
    },

    isPassDeleteTagGroup(param) {
      if(param) {
        this.deleteTagGroup()
      }
    },

    isDeleteTagGroupShow(row){
      this.deleteRow = row
      this.deleteTagGroupIsShow = true
    },

    deleteTagGroup () {
      if (this.deleteRow.meetingTagGroupId != undefined && this.deleteRow.meetingTagGroupId != null && this.deleteRow.meetingTagGroupId != '') {
        this.showLoading = true;
        SystemManageApi.OutlookBuildMeetingTagGroupDelete(this.deleteRow.meetingTagGroupId)
          .then(({ data }) => {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return;
            }

            this.deleteSuccess(this.deleteRow.meetingTagGroupName);
            this.meetingTagGroupList = []
            this.deleteRow = null
            this.loadTagInfo();
          })
          .catch((error) => {
            errorCodeMsg(error, this);
          })
          .finally(() => {
            this.showLoading = false;
          });
      }
    },

    getDisplayOrder () {
      const createdList = this.meetingTagGroupList.filter(el => el.meetingTagGroupId != '' && el.meetingTagGroupId != null && el.meetingTagGroupId != undefined)
      return createdList.length + 1
    },

    saveTagGroup (row) {
      if (row.meetingTagGroupName != '' && row.meetingTagGroupName != null) {
        const tagGroup = {
          meetingTagGroupName: row.meetingTagGroupName,
          displayOrder: this.getDisplayOrder(),
        };
        this.showLoading = true
        SystemManageApi.OutlookBuildMeetingTagGroupCreate(this.paramBuildingId, tagGroup)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if (data.statusCode == "Success") {
              const createdList = this.meetingTagGroupList.filter(el => el.meetingTagGroupId != '' && el.meetingTagGroupId != null && el.meetingTagGroupId != undefined)
              const newList = this.meetingTagGroupList.filter(el => el.meetingTagGroupId == '' || el.meetingTagGroupId == null || el.meetingTagGroupId == undefined)
              createdList.sort((a, b) => a.index - b.index)
              newList.sort((a, b) => a.index - b.index)
              this.meetingTagGroupList = []
              for (const obj of createdList) {
                this.meetingTagGroupList.push(obj)
              }
              for (const obj of newList) {
                this.meetingTagGroupList.push(obj)
              }
              this.changeTableIndex()

              row.meetingTagGroupId = data.body.meetingTagGroupId
              row.meetingTagGroupName = data.body.meetingTagGroupName
              row.homeDisplayFlag = false
              row.showFlag = false
              row.reserveTopDisplayStatus = null
              row.displayOrder = data.body.displayOrder
              row.meetingTagList = []
              row.index = data.body.displayOrder

              this.meetingTagGroupList.sort(function (a, b) {
                let sortCd = 0
                if (a.meetingTagGroupId && !b.meetingTagGroupId) {
                  sortCd = -1
                } else if (!a.meetingTagGroupId && b.meetingTagGroupId) {
                  sortCd = 1
                }
                return sortCd || a.index - b.index
              })
            } else {
              this.$messageIotError("タググループ保存に失敗しました")
            }
          })
          .finally(() => {
            this.showLoading = false
          });
      } else {
        this.$messageIotError(this.$t('message.common.validation.required', {
          field: "タググループ"
        }))
      }
    },

    tagGroupEditing (row) {
      if(this.areArraysEqual(this.meetingTagGroupList, this.earlyViewMeetingTagGroupList) && this.areArraysEqual(this.meetingTagGroupList, this.earlyViewMeetingTagGroupList) && this.areArraysEqual(this.UnclassifiedTags, this.earlyViewUnclassifiedTags)){
        this.btnFlag = ''
        this.$router.push({
          name: "outlookTagGroupsEditing",
          params: {
            meetingTagGroupId: row.meetingTagGroupId
          },
          query: {
            buildingId: this.paramBuildingId
          },
        });
      }else{
        this.msgParam = "変更のデータを保存しますか?"
        this.btnFlag = 'tagGroupEditing'
        this.centerDialogVisibleIsShow = true
        this.paramTagGroupId = row.meetingTagGroupId
      }
    },

    addTags (row) {
      if (this.newMeetingTagName != '' && this.newMeetingTagName != null) {
        row.meetingTagList.push({
          meetingTagId: null,
          meetingTagName: this.newMeetingTagName,
          displayOrder: row.meetingTagList.length + 1
        });
        this.newMeetingTagName = '';
        row.showFlag = false;
      }
    },

    startDrag (index, sourceTagList) {
      this.sourceIndex = index;
      this.sourceTagList = sourceTagList;
    },

    handleDrop (targetTagList, targetIndex) {
      if (!this.$checkAuth('010310')) {
        return
      }

      if (targetTagList.length >= 20) {
        return
      }

      if (this.sourceIndex != null && this.sourceTagList) {
        const draggedItem = this.sourceTagList.splice(this.sourceIndex, 1)[0];
        targetTagList.splice(targetIndex, 0, draggedItem);
        this.sourceTagList.forEach((sourceTag, i) => {
          sourceTag.displayOrder = i + 1
        })
        targetTagList.forEach((targetTag, i) => {
          targetTag.displayOrder = i + 1
        })
        this.sourceIndex = null;
        this.targetTagList = null;
      }
    },

    deleteSuccess (field) {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: field,
      }));
    },

    clickFn () {
      if(this.areArraysEqual(this.meetingTagGroupList, this.earlyViewMeetingTagGroupList) && this.areArraysEqual(this.UnclassifiedTags, this.earlyViewUnclassifiedTags)){
        this.btnFlag = ''
        this.showLoading = false
        this.showTagPopup = true;
      }else{
        this.msgParam = "変更のデータを保存しますか？"
        this.btnFlag = 'tagGroupDisplaySettings'
        this.centerDialogVisibleIsShow = true
      }
    },

    closePopup(){
      this.loadTagInfo();
    },
    rowMerge ({ row, columnIndex }) {
      if (
        columnIndex === 1 &&
        (row.meetingTagGroupId == '' || row.meetingTagGroupId == null || row.meetingTagGroupId == undefined)
      ) {
        return {
          rowspan: 1,
          colspan: 4
        }
      } else if (
        (columnIndex === 2 || columnIndex === 3 || columnIndex === 4) &&
        (row.meetingTagGroupId == '' || row.meetingTagGroupId == null || row.meetingTagGroupId == undefined)
      ) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }
}
</script>

<style scoped>
.buttons .btn {
  width: 56px;
  height: 32px;
  padding: initial;
  margin: 0 0 0 8px;
}

.display-order {
  display: flex;
  align-items: center;
}

.orderBtns {
  display: inline-flex;
  width: 60px;
  height: 24px;
  gap: 4px;
}

.orderBtns .orderButton {
  display: inline-block;
  width: 28px;
  height: 24px;
  padding: 5px 5px 7px 5px;
  margin: 0 0 0 4px;
  font-size: 25px;
}

.el-icon-caret-top {
  position: absolute;
  left: 0px;
  top: -1px;
}

.el-icon-caret-bottom {
  position: absolute;
  left: 0px;
  top: -1px;
}

.abled{
  color: #519AA4;
}

.disabled{
  color: #DFDFDF;
}

.introduce {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #525250;
}

.introduce li {
  list-style: disc;
  margin: 0px 15px;
}

.tips {
  display: flex;
  align-items: center;
  border-radius: 20px;
  border: 1px dashed #B8B8B4;
  min-height: 68px;
  padding: 15px;
  padding-left: 26px;
  margin: 40px 0px 31px 0;
}
.tips-left {
  min-width: 168px;
}
.tips-right {
  width: calc(100% - 208px);
}
.tips h4 {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  color: #6B6B69;
}
.tips p {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
}

.bottom-btn {
  display: flex;
}

.add-tag-btn {
  display: inline-block;
}
.add-tag-btn::v-deep .el-button {
  width: 156px;
  height: 32px;
}

.tag-preferences-btn {
  margin-left: auto;
  width: 208px;
  height: 32px;
}

.tags-display {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  border-radius: 30px;
  border:0;
  color: #525250;
  height: 26px;
  line-height: 26px;
  padding: 0px 12px 0px 12px;
  box-shadow: 4px 4px 8px 0px #E6E6D8,-4px -4px 5px 0px #FFFFFF;
  background: #F2F2ED;
}

.tag:hover {
  opacity: 0.6;
}

.addNewTag {
  display: inline-block;
  position: relative;
}

.addNewTag:hover {
  opacity: 0.6;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.input-group {
  display: flex;
  align-items: center;
}

::v-deep .input-group .el-input {
  width: 160px;
}

::v-deep .input-group .el-input .el-input__inner {
  width: 160px;
  height: 36px !important;
}

.tag_group_name {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
}

.inputBtn {
  display: flex;
  margin-left: 12px;
}

.inputBtn .btn {
  width: auto;
  height: 32px;
  cursor: pointer;
}

.inputBtn .btn:hover {
  opacity: 1 !important;
}

.inputBtn .btn-save {
  color: #fff;
  background-color: #329CA6;
}

.inputBtn .btn-save:hover {
  color: #fff !important;
}

::v-deep .inputBtn .my-button + .my-button {
  margin-left: 8px;
}

.btn-edit{
  width: 52px!important;
  height: 32px!important;
}

.btn-remove{
  width: 52px!important;
  height: 32px!important;
}

.tag-input{
  position: relative;
  left: -9px;
}

.cancel-btn,
.create-btn::v-deep .el-button {
  width: 152px;
  height: 32px;
}

::v-deep .el-tag .el-icon-close::before {
  color: #519AA4;
  font-size: 16px;
}

::v-deep .el-tag .el-tag__close:hover {
  background-color: #E6E6D8;
}

</style>
